import { useNavigate } from "react-router-dom";
import "./AcademicsPage.css";

function PgAcademics() {

 const navigate = useNavigate();

  return (
    <div className="image-links-container">

      <div className="image-card" onClick={() => navigate("/academics")}>
        <img src="/images/courses.png" alt="Academics" />
        <h3>Courses Offered</h3>
      </div>

      <div className="image-card" onClick={() => navigate("/links")}>
        <img src="/images/academic.png" alt="Useful Links" />
        <h3>Academic Calendar</h3>
      </div>

      <div className="image-card" onClick={() => navigate("/contact")}>
        <img src="/images/Facilities.png" alt="Contact Us" />
        <h3>Facilities</h3>
      </div>

      <div className="image-card" onClick={() => navigate("/about")}>
        <img src="/images/achive.png" alt="About Us" />
        <h3>achievements</h3>
      </div>

    </div>
  );
}
export default PgAcademics;
